export interface ChipGroupProps {
  children: React.ReactNode
  className?: string
  variant?: ChipGroupVariantType
}

export enum ChipGroupVariant {
  primary = 'primary',
  contrast = 'contrast',
}

export type ChipGroupVariantType = `${ChipGroupVariant}`
